// extracted by mini-css-extract-plugin
module.exports = {"list":"PurchaseDetailsPage_list__3S3UD","listContainer":"PurchaseDetailsPage_listContainer__2ojyi"};